import TreedisAdminDAO from '@/api/TreedisAdminDAO';
import { GameAnalytic } from '@/_models/game/GameAnalytic';

export default class GameAnalyticService {
  analytic: GameAnalytic;

  constructor(gameId: number, slug: string) {
    this.analytic = new GameAnalytic({
      gameId,
      country: '',
      startDateTime: new Date(), // user local time
      slug,
    });
    window.addEventListener('beforeunload', () => this.update());
  }

  public getTime() {
    return this.analytic.time;
  }

  public setTime(time: number) {
    this.analytic.time = time;
  }

  public getPoint() {
    return this.analytic.point;
  }

  public setPoint(point: number) {
    this.analytic.point = point;
  }

  public async update(data: any = {}) {
    const obj = { ...data };
    if (obj.id) delete obj.id;
    const newAnalytic = new GameAnalytic({ ...this.analytic, ...obj });
    if (this.analytic.time) {
      const res = await this.saveAnalytics(newAnalytic);
      if (res) {
        this.analytic = new GameAnalytic(res.data);
      }
    }
  }

  // eslint-disable-next-line class-methods-use-this
  private saveAnalytics(analytic: GameAnalytic) {
    return TreedisAdminDAO.saveAnalytics(analytic);
  }
}
